import React from "react";
import * as Yup from 'yup';
import { ToastContainer } from "react-toastify";
import LockIcon from '@mui/icons-material/Lock';
import { ErrorMessage, Field, Form, Formik } from "formik";

import './Form.css';
import FormTitle from "../../molecules/form-title/FormTitle";
import Copyright from "../../molecules/copyright-footer/Copyright";

const NewPwd = ()=>{
    const validate = Yup.object({
        password: Yup.string()
        .min(8, 'Password should contain at least 8 characters')
        .required('Fill this field'),
        confirm_password: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Fill this field')
    })

    return(
        <Formik
        initialValues={{
            password: '',
            confirm_password: ''
        }}
        validationSchema={validate}
        onSubmit={(values)=>{

        }}
        >
            {
                formik => (
                    <Form className="formContainer" onSubmit={formik.handleSubmit}>
                        <ToastContainer />
                        <FormTitle title="Create new password" text="Your new password must be different from previous used password" />
                        <div className="formField" id="sponsorRegistration">
                            <div className="fieldAndIcon">
                                <div className="icon">
                                    <LockIcon />
                                </div>
                                <Field autoComplete="off" className="formInput" id="password" name="password" type="password" placeholder="Password" onChange={formik.handleChange} value={formik.values.password} />
                            </div>
                            <ErrorMessage name="password" component="div" className="loginError" />
                            <div className="fieldAndIcon">
                                <div className="icon">
                                    <LockIcon />
                                </div>
                                <Field autoComplete="off" className="formInput" id="confirm_password" name="confirm_password" type="password" placeholder="Confirm Password" onChange={formik.handleChange} value={formik.values.confirm_password} />
                            </div>
                            <ErrorMessage name="confirm_password" component="div" className="loginError" />
                            <Field className="pwdSubmitBtn" type="submit" value = "Submit" />
                        </div>
                    </Form>
                )
            }
        </Formik>
    )
}

export default NewPwd;